'use client'

import { motion, useInView } from 'motion/react'
import TypingText from './TypingText'
import { useRef } from 'react'
import { IconBrandLinkedin } from '@tabler/icons-react'
import { IconBrandGithub } from '@tabler/icons-react'
import { IconBrandGitlab } from '@tabler/icons-react'
import { IconMail } from '@tabler/icons-react'

export const HeadHome = () => {
  const typingRef = useRef(null)
  const isInView = useInView(typingRef, { once: true })

  return (
    <section role='region' aria-label='Encabezado de presentación' className='header-section'>
      <motion.h1
        role='heading'
        aria-level='1'
        tabIndex={0}
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className='text-2xl md:text-3xl'
        style={{
          background: 'linear-gradient(45deg, #FFE135, #4CAF50, #FDD835)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textShadow: '0 0 5px rgba(255,225,53,0.3)'
        }}
        whileHover={{
          background: 'linear-gradient(45deg, #FFD700, #228B22, #FFEB3B)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textShadow: '0 0 20px rgba(255,225,53,0.8), 0 0 60px rgba(255,225,53,0.6)',
          filter: 'drop-shadow(0 0 12px rgba(255,225,53,0.7))',
          scale: 1.04
        }}
        aria-label='Saludo de bienvenida'
      >
        Hola! Soy Alejandro Vega 🍍
        <span className='sr-only'>(piña)</span>
      </motion.h1>
      <motion.div
        ref={typingRef}
        role='complementary'
        aria-label='Descripción personal'
        tabIndex={0}
        initial={{ y: -20, opacity: 0 }}
        animate={isInView ? { y: 0, opacity: 1 } : { y: -20, opacity: 0 }}
        transition={{ duration: 0.8, delay: 0.8 }}
        style={{
          marginTop: '0.3em',
          fontSize: '0.7em',
          textShadow: '0 0 25px rgba(76,175,80,0.6), 0 0 50px rgba(76,175,80,0.4)',
          minHeight: '3em',
          width: '100%',
          maxWidth: '800px'
        }}
      >
        <TypingText
          text='Estudioso, diseñador y ejecutor constante en el desarrollo tecnológico del día a día 👨🏻‍💻'
          animate={isInView}
          waitTime={2000}
          aria-live='polite'
          delay={45}
          className='text-center text-lg md:text-2xl font-bold text-gray-800 dark:text-gray-200'
        />
      </motion.div>
    </section>
  )
}
HeadHome.displayName = 'Encabezado de presentación'

export default HeadHome
